import React, { useState, useEffect, useRef } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { newProduct, resetForm } from '../../actions/adminProducts';
import ProductForm, { ProductFormValues } from './ProductForm';

const EMPTY: ProductFormValues = {
  name: '', description: '', benefits: '', didYouKnow: '',
  productCode: '', origin: '', unitSize: '', category: '',
  subCategory: '', price: '', inStock: 'inStock',
};

const NewProduct = ({ adminProducts, newProduct, resetForm }: any) => {
  const history = useHistory();
  const [values, setValues] = useState<ProductFormValues>(EMPTY);
  const [image, setImage] = useState<File | null>(null);
  const [didYouKnowImage, setDidYouKnowImage] = useState<File | null>(null);
  const [productImageUrl, setProductImageUrl] = useState('');
  const [didYouKnowImageUrl, setDidYouKnowImageUrl] = useState('');
  const [errors, setErrors] = useState<any>({});
  const [showSuccess, setShowSuccess] = useState(false);

  const prevRef = useRef(adminProducts);

  useEffect(() => {
    return () => { resetForm(); };
  }, []);

  useEffect(() => {
    const prev = prevRef.current;
    if (adminProducts.errors !== prev.errors) setErrors(adminProducts.errors);
    if (adminProducts.newProduct !== prev.newProduct) {
      setShowSuccess(true);
      setValues(EMPTY);
      setImage(null);
      setDidYouKnowImage(null);
      setProductImageUrl('');
      setDidYouKnowImageUrl('');
      setErrors({});
    }
    prevRef.current = adminProducts;
  }, [adminProducts]);

  const onChange = (e: any) => {
    const name = e.target.name;
    let value = e.target.value;
    if (name === 'price' && value !== '') value = parseFloat(value);
    const newErrors = { ...errors };
    delete newErrors[name];
    setErrors(newErrors);
    setValues((prev) => ({ ...prev, [name]: value }));
  };

  const onImageSelect = (e: any) => {
    const fieldName = e.target.name;
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onloadend = () => {
      if (fieldName === 'image') { setImage(file); setProductImageUrl(reader.result as string); }
      if (fieldName === 'didYouKnowImage') { setDidYouKnowImage(file); setDidYouKnowImageUrl(reader.result as string); }
    };
    reader.readAsDataURL(file);
  };

  const handleFormSubmit = (e: any) => {
    e.preventDefault();
    const formData = new FormData();
    if (image) formData.append('image', image);
    if (didYouKnowImage) formData.append('didYouKnowImage', didYouKnowImage);
    Object.entries(values).forEach(([k, v]) => {
      if (k === 'inStock') { formData.append('inStock', String(v === 'inStock')); return; }
      if (v !== '') formData.append(k, String(v));
    });
    newProduct(formData);
  };

  return (
    <div>
      <Helmet>
        <title>New Product - Frozberries Victoria</title>
        <meta name="description" content="New Product - Frozberries Victoria" />
      </Helmet>

      {showSuccess && adminProducts.newProduct && (
        <div className="admin-card" style={{ marginBottom: 16, padding: 16, display: 'flex', alignItems: 'center', gap: 16 }}>
          <img src={adminProducts.newProduct.image} alt={adminProducts.newProduct.name} style={{ height: 60, borderRadius: 6, objectFit: 'cover' }} />
          <div>
            <p style={{ margin: 0, fontWeight: 600 }}>{adminProducts.newProduct.name} created successfully.</p>
            <button
              className="admin-dropdown-trigger"
              style={{ marginTop: 6 }}
              onClick={() => history.push(`/shop/${adminProducts.newProduct.name.replace(/[^A-Z0-9]+/gi, '-')}/${adminProducts.newProduct._id}`)}
            >
              View in shop
            </button>
          </div>
        </div>
      )}

      <div className="admin-card">
        <div className="admin-card-header">
          <p className="admin-card-title">New Product</p>
        </div>
        <div className="admin-card-body">
          <ProductForm
            values={values}
            errors={errors}
            productImageUrl={productImageUrl}
            didYouKnowImageUrl={didYouKnowImageUrl}
            onChange={onChange}
            onImageSelect={onImageSelect}
            onSubmit={handleFormSubmit}
            onBack={() => history.push('/adminpanel/products')}
            submitLabel="Create product"
            loading={adminProducts.loading}
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => ({ adminProducts: state.adminProducts });
export default connect(mapStateToProps, { newProduct, resetForm })(NewProduct);
